// Game Controller
//
// The game controller tracks and looks after the current game state, and orchestrates components

gameController = {};
gameController.isPrePaid = false;
gameController.freeSpinsLeft = 0;
gameController.inFreeSpins = false;
gameController.inCashLink = false;
gameController.moonSymAnimating = false;
gameController.gameLoaded = false;
gameController.wildBounceSymAnimating = false;
gameController.inMultiplierAnim = false;
gameController.stakeChanged = false;
gameController.inCoinAwardsModifier = false;
gameController.inCashLinkAwardDisplay = false;

gameController.powerPackDisplay = undefined;
gameController.bigWin - undefined;
gameController.hasBeenWinCapped = false;
gameController.cyclingWins = false;
gameController.canSkipWin = false;
gameController.spinComplete = false;
gameController.isInWolfRun = false;
gameController.cyclingWinsIndex = 0;
gameController.slamStopped = false;
gameController.skipWinsPressed = false;

gameController.cashLinkReelIsSpinSpinning = [];
gameController.symbolFramePanels = [];
gameController.preRespinWinnings = 0;
gameController.startNextSpin = false;
gameController.cachedStart = false;
gameController.cashLinkPayout = false;
gameController.cashLinkBonusIsPossible = false;
gameController.winSkipped = false;
gameController.spinHasWin = false;
gameController.powerPackSymAnimating = false;
gameController.cashLinkSkip = false;
gameController.coinAwardsSkip = false;
gameController.cashLinkSymAnimating = false;
gameController.coinSymAnimating = false;
gameController.playSingleBonus = true;
gameController.bonusSymbolsLanded = 0;
gameController.moonsSymbolsLanded = 0;

gameController.coinsSymbolsLanded = 0;
gameController.powerPackSymbolsLanded = 0;
gameController.cashLinkLanded = 0;
gameController.moonQty = 4;
gameController.ppTotalSymbolValue = undefined;

gameController.countingMoons = false;

gameController.potContainer = undefined;

gameController.minBonusForFeature = 3; //should be data driven
gameController.minBonusForFeature2 = 8; //should be data driven
gameController.minBonusForFeature2Anticipation = 5; //should be data driven
gameController.wildSymbolsToStandOut = [];
gameController.animWinsFinished = true;
gameController.reelData = [];

gameController.wildTimers = [];

gameController.loseStreak = 0;

gameController.reelsAlreadyLanded = [];

gameController.retriggerTask = undefined;
gameController.doBigWinShake = false;

gameController.idleMusicTimer = undefined;

gameController.inBuyABonus = false;
gameController.buyABonusCashLink = false;
gameController.inBuyABonusRecovery = false;

gameController.platformPopupActive = false;

gameController.coinLandSounds = ["coinLand1", "coinLand2", "coinLand3"];

gameController.justHadFreeSpins = false;
gameController.wasCashLink = false;

// for multiple reel spin sounds
gameController.reelspins = ["reelSpin"];
gameController.reelspinId = 0;
gameController.inCashLink = false;

gameController.muteCyclingWins = false;
gameController.cashLink = undefined;

gameController.cashLinkCoin = undefined;

gameController.freespinsWinnings = 0;
gameController.potBonusWinnings = 0;

gameController.moonValues = [];
gameController.coinValues = [];
gameController.powerPacksOnReel = [];
gameController.powerPacksLanded = [];
gameController.powerPackValues = [];

gameController.wasInCoinAwardsMod = false;
gameController.reelStopping = [false, false, false, false, false, false];
gameController.valuesOffReels = [false, false, false, false, false, false];
gameController.multiplier = 0;
gameController.cashLinkWinnings = 0;
gameController.totalWinBeforeFreeSpins = 0;

gameController.justLeftBuyABonus = false;
gameController.justEnteredBuyABonus = false;

gameController.fullGameWinnings = 0;
gameController.stoppingAutoplay = false;

//Oversized symbols
gameController.overSizedInProcess = false;
gameController.overSizedSymbols = [];
gameController.winningOversizedSymbols = [];
gameController.nonWinningOversizedSymbols = [];
gameController.overSizedSymbolsAnimator = undefined;
gameController.overSizedGroup = [
  8, 9, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
];

gameController.initialise = function () {
  gameController.bigWin = resourceManager.get("bigWin");
  freespinsMultiplierAnim.initialise();

  resourceManager.get("logoFreeSpins").visible = false;
  resourceManager.get("logoWolfRun").visible = false;
  resourceManager.get("slotContainer:multiplierContainer").visible = false;

  gameController.slotMachine = resourceManager.getController("SlotMachine");
  const reelNames = ["reel0", "reel1", "reel2", "reel3", "reel4", "reel5"];
  gameController.slotMachine.subscribeToReelsLandedEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    if (gameController.reelsAlreadyLanded.indexOf(reel) === -1) {
      gameController.onSpinLand(reel);
    }
    gameController.reelsAlreadyLanded.push(reel);
  });
  gameController.slotMachine.subscribeToReelsHitEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    gameController.playLandSounds(reel);
    gameController.onSpinHit(reel);
  });

  gameController.pots = resourceManager.get("potsContainer");

  for (let i = 0; i < gameData.numReels; ++i) {
    let rv = resourceManager.get("slotContainer:reelContainer:reel" + i);

    rv.reassignSlotMachine(gameController.slotMachine);
  }
  gameController.reelDark = resourceManager.get("reelDarkContainer:reelDark");
  gameController.reelDark.beginFill(0x000000);
  gameController.reelDark.lineStyle(0, 0x000000);
  gameController.reelDark.drawRect(0, 0, 1, 1);
  gameController.reelDark.scale.x = 1055;
  gameController.reelDark.scale.y = 550;
  gameController.reelDark.x = 135;
  gameController.reelDark.y = 145;
  gameController.reelDark.visible = false;
  gameController.setupSlotAnimVisuals();

  gameController.redrawSymbols(gameController.slotMachine);

  gameController.slotMachine.selectReelMode("default");

  gameController.topValueOverlays = resourceManager.get(
    "slotContainer:topValueOverlays"
  );

  gameController.valuesSpin = resourceManager.get("slotContainer:valuesSpin");
  gameController.valuesMoons = resourceManager.get("slotContainer:valuesMoons");

  gameController.cashLink = resourceManager.get(
    "slotContainer:cashLinkFeatureContainer:cashLinkFeature"
  );

  for (let reel = 0; reel < gameData.numReels; reel++) {
    for (let row = 0; row < gameData.numRows; row++) {
      gameController.cashLinkReelIsSpinSpinning.push(false);
    }
  }

  gameController.originalStopDistances =
    gameController.slotMachine._currentMode.stopDistances;

  gameController.winningsContainer = resourceManager.get("winningsContainer");
  gameController.winningsContainer.visible = false;

  gameController.longSpinBlue = resourceManager.get(
    "slotContainer:reelEffects:longSpinBlue"
  );
  gameController.longSpinBlue.gotoAndStop(0);

  gameController.longSpinOrange = resourceManager.get(
    "slotContainer:reelEffects:longSpinOrange"
  );
  gameController.longSpinOrange.gotoAndStop(0);

  gameController.longSpinOrangeTween = gsap.fromTo(
    gameController.longSpinOrange,
    {
      alpha: 0,
    },
    {
      alpha: 1,
      duration: 0.25,
      paused: true,
      repeat: 2,
      immediateRender: false,
      yoyo: true,
      onStart: () => {
        gameController.longSpinOrange.visible = true;
      },
      onComplete: () => {},
    }
  );

  gameController.longSpinBlueTween = gsap.fromTo(
    gameController.longSpinBlue,
    {
      alpha: 0,
    },
    {
      alpha: 1,
      duration: 0.25,
      paused: true,
      repeat: -1,
      immediateRender: false,
      yoyo: true,
      onStart: () => {
        gameController.longSpinBlue.visible = true;
      },
      onComplete: () => {},
    }
  );

  gameController.winlinePopup = resourceManager.get("winlinePopupContainer");
  gameController.winlinePopup.visible = false;
  gameController.winlinePopupText = resourceManager.get(
    "winlinePopupContainer:linePays"
  );

  gameController.stopAnticipation();

  gameController.messageBox = resourceManager.get(`messageBox:messageBox`);

  for (let i = 0; i < gameData.numReels; i++) {
    gameController.reelData.push(
      resourceManager.get("slotContainer:reelContainer:reel" + i)
    );
  }

  gameController.winControllerMain =
    resourceManager.getController("WinControllerMain");

  gameController.scatterSymbolReels = [];

  gameController.symbolAnimator = resourceManager.get(
    "slotContainer:SymbolAnimator"
  );

  gameController.overSizedSymbolsAnimator = resourceManager.get(
    "slotContainer:OversizedSymbolAnimator"
  );

  gameController.powerPackDisplay = resourceManager.get(
    "slotContainer:powerPackAwardDisplay"
  );

  gameController.bonusLandAnimator = resourceManager.get(
    "slotContainer:BonusLandAnimator"
  );

  gameController.wildLandAnimator = resourceManager.get(
    "slotContainer:WildLandAnimator"
  );

  gameController.wildWolfRun = resourceManager.get(
    "slotContainer:wildWolfDisplay"
  );

  resourceManager.get("featurePopupContainer:darkBackground").visible = false;

  gameController.onOrientationChange();

  gameController.shaker = resourceManager.get("slotShaker");
  gameController.nightBackground = resourceManager.get(
    "landscapeBackground:freespinsBackground"
  );
  gameController.nightBackgroundPortrait = resourceManager.get(
    "portraitBackground:freespinsBackground"
  );

  gameController.popoutInitialWilds();
};

gameController.setupSlotAnimVisuals = function () {
  for (var reel = 0; reel < gameData.numReels; reel++) {
    var symbolFrames = [];

    for (var row = 0; row < gameData.numRows; row++) {
      let pos = helpers.getSymbolPos(reel, row);

      var symbolFrame = resourceManager.createObject(
        "movie",
        "symbolFrame" + reel + "_" + row,
        "symbolFrameContainer",
        {
          definition: "symbolFrame",
          x: pos.x,
          y: pos.y,
          anchor: 0.5,
          scale: 1.0,
          loop: false,
        }
      );
      symbolFrame.gotoAndStop(0);
      symbolFrame.visible = false;
      symbolFrames.push(symbolFrame);
    }
    gameController.symbolFramePanels.push(symbolFrames);
  }
};

gameController.redrawSymbols = function (sm) {
  let reelVisuals = sm._reelVisuals;
  for (let i = 0; i < reelVisuals.length; ++i) {
    reelVisuals[i].redraw();
  }
};

gameController.popoutInitialWilds = function () {
  const symbols = resourceManager.getConfiguration().symbols;
  let symbolsToAnimate = [];
  for (
    let reel = 0;
    reel < gameData.slotConfig.startingSymbols.length;
    ++reel
  ) {
    for (
      let row = 0;
      row < gameData.slotConfig.startingSymbols[reel].symbols.length;
      ++row
    ) {
      const symbolId =
        gameData.slotConfig.startingSymbols[reel].symbols[row].value;
      if (symbolId === symbols["Symbol_Wild_1x1"].ID) {
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: symbols["Symbol_Wild_1x1"].ID,
        };
        gameController.wildSymbolsToStandOut.push(symbolData);
        symbolsToAnimate.push(symbolData);
      } else if (symbolId === symbols["Symbol_Wild_1x2"].ID) {
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: symbols["Symbol_Wild_1x2"].ID,
        };
        gameController.wildSymbolsToStandOut.push(symbolData);
        symbolsToAnimate.push(symbolData);
      } else if (symbolId === symbols["Symbol_Wild_1x3"].ID) {
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: symbols["Symbol_Wild_1x3"].ID,
        };
        gameController.wildSymbolsToStandOut.push(symbolData);
        symbolsToAnimate.push(symbolData);
      }
    }
  }

  if (symbolsToAnimate.length > 0) {
    gameController.wildLandAnimator.animateSymbols(
      symbolsToAnimate,
      gameController.slotMachine,
      true,
      false,
      function () {}
    );
  }
};

gameController.playLandSounds = function (reel) {
  if (!gameController.slamStopped || reel === 0) {
    if (
      !gameController.isInWolfRun ||
      !gameController.wildWolfRun.checkWolf(reel)
    ) {
      soundManager.play("reelStop" + reel);
    }
  }
};

gameController.start = function () {
  gameController.stateMachine.switchState("WAITING_FOR_START");
};

gameController.onSpinComplete = function () {
  gameController.stopAnticipation();
  gameController.valuesSpin.removeAllChildren();
  gameController.spinComplete = true;
  soundManager.stop("reelSpin");

  gameController.setState_WaitingForServer(gameController.spinTask);
};

gameController.countSymbolOnReel = function (reel, symbolString) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultsPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultsPanel.reelList[reel].symbols;
  }
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }

  const symbols = resourceManager.getConfiguration().symbols;

  const found = reelSymbols.find(function (symbol) {
    return symbol.value === symbols[symbolString].ID;
  });

  if (found !== undefined) {
    return 1;
  } else {
    return 0;
  }
};

gameController.countMoonsOnReel = function (reel) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }
  let numOfMoons = 0;
  const symbols = resourceManager.getConfiguration().symbols;
  reelSymbols.forEach(function (row) {
    if (row.value === symbols["Symbol_Moon"].ID) {
      ++numOfMoons;
    }
  });

  return numOfMoons;
};

gameController.countCoinsOnReel = function (reel) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }
  let numOfCoins = 0;
  const symbols = resourceManager.getConfiguration().symbols;
  reelSymbols.forEach(function (row) {
    if (row.value === symbols["Symbol_Coin"].ID) {
      ++numOfCoins;
    }
  });

  return numOfCoins;
};

gameController.hasCashLinkOnReel = function (reel) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }
  let numOfCashLinks = 0;
  reelSymbols.forEach(function (row) {
    if (row.value === gameData.symbols["Symbol_Cashlink"].ID) {
      numOfCashLinks++;
    }
  });

  return numOfCashLinks;
};

gameController.countPowerPacksOnReel = function (reel) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }
  let numPowerPack = 0;
  const symbols = resourceManager.getConfiguration().symbols;
  reelSymbols.forEach(function (row) {
    if (row.value === symbols["Symbol_Power_Pack"].ID) {
      ++numPowerPack;
    }
  });

  return numPowerPack;
};

gameController.countRetriggerBonusOnReel = function (reel) {
  return gameController.countSymbolOnReel(reel, "Symbol_Moon");
};

gameController.onSpinHit = function (reel) {
  const self = this;

  const reelSymbols =
    gameController.spinTask.data.resultPanel.reelList[reel].symbols;

  let moonsOnReel;
  let coinsOnReel;
  let powerPacksOnReel;

  const moonsLandedBefore = gameController.moonsSymbolsLanded;

  if (reel === 5) {
    gameController.messageBox.onSpinEnd();
  }

  if (gameController.moonValues.length > 0) {
    moonsOnReel = gameController.countMoonsOnReel(reel);
    gameController.moonsSymbolsLanded += moonsOnReel;
  }

  if (gameController.coinValues.length > 0) {
    coinsOnReel = gameController.countCoinsOnReel(reel);
    gameController.coinsSymbolsLanded += coinsOnReel;
  }

  if (reel === 0 || (reel === 5 && gameController.powerPackValues.length > 0)) {
    powerPacksOnReel = gameController.countPowerPacksOnReel(reel);
    gameController.powerPackSymbolsLanded += powerPacksOnReel;
  }

  //TODO: Needs to be tidied up..only 1 cashlink coin lands
  if (
    gameController.cashLinkCoin ||
    gameController.hasCashLinkOnReel(reel) > 0
  ) {
    gameController.cashLinkBonusIsPossible = true;
  }

  const reelsNotLanded = gameData.numReels - reel;

  if (moonsOnReel) {
    for (let row = 0; row < reelSymbols.length; ++row) {
      for (let i = 0; i < gameController.moonValues.length; i++) {
        if (
          gameController.moonValues[i].reel === reel &&
          gameController.moonValues[i].row === row
        ) {
          let symbolData = {
            cell: { reel: reel, row: row },
            symbolId: gameController.moonValues[i].symbolId,
            slotCell: gameController.moonValues[i].slotCell,
            oversizedPlayed: false,
            oversizedSymbolID: gameData.symbols[`Symbol_Moon_Spin`].ID,
            moonData: gameController.moonValues[i],
          };
          gameController.overSizedSymbols.push(symbolData);
          const moonLandSound = moonsLandedBefore > 0 ? "fsLand2" : "fsLand1";
          if (gameController.slamStopped) {
            if (gameController.playSingleBonus) {
              soundManager.play(moonLandSound);
              gameController.playSingleBonus = false;
            }
          } else {
            soundManager.play(moonLandSound);
          }

          gameController.valuesMoons.showMoonValue(
            true,
            symbolData.slotCell,
            gameController.moonValues[i].numberOfSpins
          );

          gameController.valuesMoons.animateMoonValue(symbolData.slotCell);

          gameController.bonusLandAnimator.animateSymbols(
            [symbolData],
            gameController.slotMachine,
            true,
            false,
            function () {
              gameController.moonSymAnimating = false;
            },
            undefined,
            symbolData.moonData
          );
          gameController.moonSymAnimating = true;
        }
      }
    }
  }

  if (coinsOnReel) {
    for (let row = 0; row < reelSymbols.length; ++row) {
      if (reelSymbols[row].value === gameData.symbols["Symbol_Coin"].ID) {
        let slotcell = reel * gameData.numRows + row;
        let coinData;
        for (let i = 0; i < gameController.coinValues.length; i++) {
          if (slotcell === gameController.coinValues[i].slotCell) {
            coinData = gameController.coinValues[i];
          }
        }

        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: gameData.symbols["Symbol_Coin"].ID,
          coinData,
        };

        gameController.bonusLandAnimator.animateSymbols(
          [symbolData],
          gameController.slotMachine,
          true,
          false,
          function () {
            gameController.coinSymAnimating = false;
          },
          coinData
        );
        if (!gameController.slamStopped) {
          gameController.coinSymAnimating = true;
        }
      }
    }
    const randIndex = Math.floor(Math.random() * self.coinLandSounds.length);
    soundManager.play(self.coinLandSounds[randIndex]);
  }

  if (gameController.cashLinkBonusIsPossible) {
    let cashLinkLand = false;
    for (let row = 0; row < reelSymbols.length; ++row) {
      if (reelSymbols[row].value === gameData.symbols["Symbol_Cashlink"].ID) {
        cashLinkLand = true;
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: gameData.symbols["Symbol_Cashlink"].ID,
        };

        gameController.bonusLandAnimator.animateSymbols(
          [symbolData],
          gameController.slotMachine,
          true,
          false,
          function () {
            gameController.cashLinkSymAnimating = false;
          }
        );
        if (!gameController.slamStopped) {
          gameController.cashLinkSymAnimating = true;
        }
      }
    }
    if (cashLinkLand) soundManager.play("cashLinkLand");
  }

  if (gameController.inFreeSpins) {
    const retrigger = gameController.countRetriggerBonusOnReel(reel);
    if (retrigger) {
      soundManager.play("fsLand1");
    }
  }

  //WILDS
  let symbolsToAnimate = [];
  let isWildWinPossible = gameController.checkIfWildWinPossible(reel);
  let biggestWildSize;
  let hitCount = 0;
  for (let row = 0; row < reelSymbols.length; ++row) {
    let symbolData;
    for (let stackNum = 1; stackNum < 5; stackNum++) {
      if (
        reelSymbols[row].value ===
        gameData.symbols[`Symbol_Wild_1x${stackNum}`].ID
      ) {
        if (stackNum > (biggestWildSize ?? 0)) biggestWildSize = stackNum;
        hitCount++;
        symbolData = {
          cell: { reel: reel, row: row },
          symbolId: gameData.symbols[`Symbol_Wild_Land_1x${stackNum}`].ID,
          oversizedPlayed: false,
          oversizedSymbolID:
            gameData.symbols[`Symbol_Wild_Oversize_1x${stackNum}`].ID,
        };
        gameController.overSizedSymbols.push(symbolData);
      }
    }
    if (isWildWinPossible && symbolData) {
      if (
        (gameController.isInWolfRun &&
          symbolData.symbolId ===
            gameData.symbols[`Symbol_Wild_Land_1x4`].ID) ||
        (gameController.isInWolfRun &&
          symbolData.symbolId === gameData.symbols[`Symbol_Wild_1x4`].ID)
      ) {
        //NOTE: if in wolf run we do not want the 1x4 wild land to animate
      } else {
        symbolsToAnimate.push(symbolData);
      }
    }
  }
  if (biggestWildSize != null && biggestWildSize > 1) {
    if (
      !gameController.isInWolfRun ||
      !gameController.wildWolfRun.checkWolf(reel)
    ) {
      soundManager.play(`bigWildLand${biggestWildSize}`);
    }
  }
  if (!gameController.slamStopped && symbolsToAnimate.length > 0) {
    gameController.wildLandAnimator.animateSymbols(
      symbolsToAnimate,
      gameController.slotMachine,
      true,
      false,
      function () {
        gameController.wildBounceSymAnimating = false;
      },
      undefined,
      undefined,
      undefined,
      true // I need to clear the oversized symbol for these to animate
    );
    gameController.wildBounceSymAnimating = true;
  }

  //WOLFEARS
  let symbolsEarsToAnimate = [];
  for (let row = 0; row < reelSymbols.length; ++row) {
    if (reelSymbols[row].value === gameData.symbols["Wolf"].ID) {
      symbolData = {
        cell: { reel: reel, row: row },
        symbolId: gameData.symbols[`Wolf`].ID,
        oversizedPlayed: false,
        oversizedSymbolID: gameData.symbols[`Wolf_Oversize`].ID,
      };
      gameController.overSizedSymbols.push(symbolData);
      if (!gameController.slamStopped) {
        symbolsEarsToAnimate.push(symbolData);
      }
    }
  }

  if (powerPacksOnReel) {
    //TODO: HB - if on last reel and coin hasnt landed then do no animate
    let symbolsToAnimate = [];
    if (gameController.powerPackSymbolsLanded) {
      for (let row = 0; row < reelSymbols.length; ++row) {
        if (
          reelSymbols[row].value === gameData.symbols["Symbol_Power_Pack"].ID
        ) {
          let hasValue = false;
          if (gameController.coinValues.length > 0) {
            hasValue = true;
          }
          let symbolData = {
            cell: { reel: reel, row: row },
            symbolId: gameData.symbols["Symbol_Power_Pack"].ID,
            oversizedSymbolID:
              gameData.symbols["Symbol_Power_Pack_Oversized"].ID,
            oversizedPlayed: false,
            hasValue: hasValue,
          };

          gameController.powerPacksLanded.push(symbolData);

          if (
            reel === 0 ||
            (reel === 5 && this.cashLinkCoin) ||
            gameController.coinValues.length > 0 ||
            gameController.moonValues.length > 0
          ) {
            if (gameController.slamStopped) {
              if (gameController.playSingleBonus) {
                soundManager.play("powerPackLand");
                gameController.playSingleBonus = false;
              }
            } else {
              soundManager.play("powerPackLand");
            }

            symbolsToAnimate.push(symbolData);
          }
          gameController.overSizedSymbols.push(symbolData);
        }
      }
      if (symbolsToAnimate.length > 0) {
        gameController.bonusLandAnimator.animateSymbols(
          symbolsToAnimate,
          gameController.slotMachine,
          true,
          false,
          function () {
            gameController.powerPackSymAnimating = false;
          },
          undefined,
          undefined,
          undefined,
          true // I need to clear the oversized symbol for these to animate
        );
        if (!gameController.slamStopped) {
          gameController.powerPackSymAnimating = true;
        }
      }
    }
  }

  //ANTICIPATION
  const freespinsBonusIsPossible = gameController.moonsSymbolsLanded > 0;
  const coinsIsPossible = gameController.coinValues.length > 0;
  let powerPackIsPossible = false;
  gameController.powerPackValues.forEach(function (pack) {
    if (pack.reel === 0) {
      powerPackIsPossible = true;
    }
  });

  if (powerPackIsPossible) {
    if (reel < gameData.numReels - 1) {
      let reelIndex = reel + 2;
      soundManager.play("anticipation" + reelIndex);
      gameController.stopAnticipation();

      if (reel === 4 && gameController.cashLinkBonusIsPossible) {
        if (gameController.inFreeSpins) {
          gameController.longSpinOrange.position.x =
            gameController.reelData[reel + 1].position.x + 10;
          gameController.longSpinOrange.visible = true;
          gameController.longSpinOrange.gotoAndPlay(0);
        } else {
          gameController.longSpinBlue.position.x =
            gameController.reelData[reel + 1].position.x + 10;
          gameController.longSpinBlue.visible = true;
          gameController.longSpinBlue.gotoAndPlay(0);
        }
      } else if (reel != 4) {
        if (gameController.inFreeSpins) {
          gameController.longSpinOrange.position.x =
            gameController.reelData[reel + 1].position.x + 10;
          gameController.longSpinOrange.visible = true;
          gameController.longSpinOrange.gotoAndPlay(0);
        } else {
          gameController.longSpinBlue.position.x =
            gameController.reelData[reel + 1].position.x + 10;
          gameController.longSpinBlue.visible = true;
          gameController.longSpinBlue.gotoAndPlay(0);
        }
      } else {
        gameController.stopAnticipation();
      }
    } else if (reel === 4) {
      gameController.stopAnticipation();
      soundManager.play("anticipation" + reelIndex);
      if (gameController.inFreeSpins) {
        gameController.longSpinOrange.position.x =
          gameController.reelData[reel + 1].position.x + 8;
        gameController.longSpinOrange.visible = true;
        gameController.longSpinOrange.gotoAndPlay(0);
      } else {
        gameController.longSpinBlue.position.x =
          gameController.reelData[reel + 1].position.x + 8;
        gameController.longSpinBlue.visible = true;
        gameController.longSpinBlue.gotoAndPlay(0);
      }
    } else {
      gameController.stopAnticipation();
    }
  } else if (freespinsBonusIsPossible || coinsIsPossible) {
    if (reel === 4) {
      gameController.stopAnticipation();

      let reelIndex = reel + 2;
      soundManager.play("anticipation" + reelIndex);
      if (gameController.inFreeSpins) {
        gameController.longSpinOrange.position.x =
          gameController.reelData[reel + 1].position.x + 10;

        gameController.longSpinOrange.visible = true;
        gameController.longSpinOrange.gotoAndPlay(0);
      } else {
        gameController.longSpinBlue.position.x =
          gameController.reelData[reel + 1].position.x + 10;
        gameController.longSpinBlue.visible = true;
        gameController.longSpinBlue.gotoAndPlay(0);
      }
    }
  } else if (gameController.cashLinkBonusIsPossible && reel === 4) {
    soundManager.play("anticipation" + 4);
    if (gameController.inFreeSpins) {
      gameController.longSpinOrange.position.x =
        gameController.reelData[reel + 1].position.x + 10;
      gameController.longSpinOrange.visible = true;
      gameController.longSpinOrange.gotoAndPlay(0);
    } else {
      gameController.longSpinBlue.position.x =
        gameController.reelData[reel + 1].position.x + 10;
      gameController.longSpinBlue.visible = true;
      gameController.longSpinBlue.gotoAndPlay(0);
    }
  } else {
    gameController.stopAnticipation();
  }
};

gameController.checkIfWildWinPossible = function (currentReel) {
  let isAWin = false;

  let occurrences = 0;
  for (let i = 0; i < gameController.spinTask.data.lines.length; i++) {
    if (gameController.spinTask.data.lines[i].occurrences > occurrences) {
      occurrences = gameController.spinTask.data.lines[i].occurrences;
    }
  }

  if (currentReel <= occurrences || currentReel < 2) {
    isAWin = true;
  }

  return isAWin;
};

gameController.onSpinLand = function (reel) {
  gameData.reels[reel].clearDimSymbolIds(0.3);

  if (reel === 5) {
    if (!gameController.inFreeSpins && !gameController.wasCashLink) {
      const stakeController = resourceManager.getController("stakeController");
      const stake = stakeController.getCurrentStake("default");

      if (gameController.spinHasWin > stake) {
        gameData.musicManager.increaseBaseLevel(
          gameController.spinHasWin,
          stake
        );

        gameController.loseStreak = 0;
      } else {
        gameController.loseStreak++;

        if (gameController.loseStreak === 10) {
        }
        gameData.musicManager.decreaseBaseLevel();
      }
    }
  }

  gameData.reelsSpinning--;
  if (gameData.reelsSpinning === 0) {
    soundManager.stop(gameController.currentReelSpin);

    gameController.stopAnticipation();

    if (gameController.bonusSymbolsLanded < gameController.minBonusForFeature) {
      gameController.bonusLandAnimator.skip();
    }
    if (gameController.moonsSymbolsLanded < gameController.minBonusForFeature) {
      gameController.bonusLandAnimator.skip();
    }
    if (gameController.coinsSymbolsLanded < gameController.minBonusForFeature) {
      gameController.bonusLandAnimator.skip();
    }
  }

  let delay =
    gameController.spinTask.data.lines.length > 0 || gameController.slamStopped
      ? 50
      : 0;

  timerManager.addTimeout(delay, function () {
    for (let i = 0; i < gameController.overSizedSymbols.length; i++) {
      if (gameController.overSizedSymbols[i].cell.reel === reel) {
        gameController.playReelOversized(reel);
        break;
      }
    }
    if (gameController.slamStopped) {
      let moons = [];

      for (let i = 0; i < gameController.moonValues.length; i++) {
        if (gameController.moonValues[i].reel === reel) {
          moons.push(gameController.moonValues[i]);
          gameData.reels[reel].setUniqueValues(
            "moon",
            gameController.moonValues[i]
          );
        }
      }
      for (let i = 0; i < gameController.coinValues.length; i++) {
        if (gameController.coinValues[i].reel === reel) {
          gameData.reels[reel].setUniqueValues(
            "coin",
            gameController.coinValues[i]
          );
        }
      }
      for (let i = 0; i < gameController.powerPackValues.length; i++) {
        if (gameController.powerPackValues[i].reel === reel) {
          gameData.reels[reel].setUniqueValues(
            "power",
            gameController.powerPackValues[i]
          );
        }
      }
      if (moons.length > 0) {
        gameController.showMoonOversized(moons);
      }
    } else {
      for (let i = 0; i < gameController.overSizedSymbols.length; i++) {
        if (gameController.overSizedSymbols[i].cell.reel === reel) {
          gameController.playReelOversized(reel);
          break;
        }
      }
    }
    if (reel === 5) {
      gameController.findWinningOverSized(gameController.spinTask.data.lines);

      if (gameController.phase.hold()) {
        if (
          !gameController.wildLandAnimator.isPlaying() ||
          !gameController.bonusLandAnimator.isPlaying()
        ) {
          gameController.overSizedInProcess = false;
          gameController.phase.step();
        }
      } else {
        gameController.overSizedInProcess = false;
      }

      if (gameController.powerPackValues.length === 0) {
        gameController.moonValues.forEach((moon) => {
          let moonSym = {
            cell: { reel: moon.reel, row: moon.row },
            symbolId: gameData.symbols["Symbol_Moon_Spin"].ID,
          };
          gameController.valuesMoons.showMoonValue(
            true,
            moon.slotCell,
            moon.numberOfSpins
          );
          gameController.valuesMoons.playMoonMovie(moon.slotCell, false);
          gameController.hideOversized(
            moonSym,
            gameData.symbols["Symbol_Moon_Spin"].ID
          );
        });
      } else {
        gameController.powerPackSymAnimating = false;
      }
      //we neeed to wait till the symbols land in place before we can play oversized movies
      if (gameController.slamStopped) {
        gameController.playAllOversizedMovies();
      }
    }
    gameController.moonValues.forEach((moon) => {
      if (moon.reel === reel) {
        gameController.valuesMoons.showMoonValue(
          true,
          moon.slotCell,
          moon.numberOfSpins
        );
      }
    });
  });
};

gameController.showMoonOversized = function (moons) {
  for (let i = 0; i < moons.length; i++) {
    gameController.valuesMoons.playMoonMovie(moons[i].slotCell, true);
  }
};

gameController.showOversizeMovie = function (symbolData) {
  if (symbolData.oversizedSymbolID) {
    symbolData.symbolId = symbolData.oversizedSymbolID;
  } else {
    symbolData.symbolId = gameController.findOversizedID(symbolData.symbolId);
  }

  gameController.overSizedSymbolsAnimator.animateSymbols(
    [symbolData],
    gameController.slotMachine,
    true,
    true,
    function () {},
    undefined,
    undefined,
    undefined,
    true
  );
};

gameController.findOversizedID = function (sym) {
  switch (sym) {
    case gameData.symbols["Symbol_Moon"].ID:
    case gameData.symbols["Symbol_Moon_Active"].ID:
    case gameData.symbols["Symbol_Moon_Spin"].ID:
      return gameData.symbols["Symbol_Moon_Spin"].ID;
    case gameData.symbols["Wolf"].ID:
    case gameData.symbols["Wolf_Oversize"].ID:
      return gameData.symbols["Wolf_Oversize"].ID;
    case gameData.symbols["Symbol_Power_Pack"].ID:
    case gameData.symbols["Symbol_Power_Pack_Oversized"].ID:
      return gameData.symbols["Symbol_Power_Pack_Oversized"].ID;
    case gameData.symbols["Symbol_Power_Pack_Total"].ID:
    case gameData.symbols["Symbol_Power_Pack_Total_Land"].ID:
      return gameData.symbols["Symbol_Power_Pack_Total_Land"].ID;
    case gameData.symbols["Symbol_Wild_Land_1x1"].ID:
    case gameData.symbols["Symbol_Wild_1x1"].ID:
    case gameData.symbols["Symbol_Wild_Oversize_1x1"].ID:
      return gameData.symbols["Symbol_Wild_Oversize_1x1"].ID;
    case gameData.symbols["Symbol_Wild_Land_1x2"].ID:
    case gameData.symbols["Symbol_Wild_1x2"].ID:
    case gameData.symbols["Symbol_Wild_Oversize_1x2"].ID:
      return gameData.symbols["Symbol_Wild_Oversize_1x2"].ID;
    case gameData.symbols["Symbol_Wild_Land_1x3"].ID:
    case gameData.symbols["Symbol_Wild_1x3"].ID:
    case gameData.symbols["Symbol_Wild_Oversize_1x3"].ID:
      return gameData.symbols["Symbol_Wild_Oversize_1x3"].ID;
    case gameData.symbols["Symbol_Wild_Land_1x4"].ID:
    case gameData.symbols["Symbol_Wild_1x4"].ID:
    case gameData.symbols["Symbol_Wild_Oversize_1x4"].ID:
      return gameData.symbols["Symbol_Wild_Oversize_1x4"].ID;
  }
};

gameController.hideAllOversized = function () {
  gameController.overSizedSymbolsAnimator.untrackOversized(
    gameController.overSizedSymbols
  );
};

gameController.findWinningOverSized = function (winningSymbols) {
  const winningSet = new Set(); //i dont want to have duplicates
  const winningOversizedSymbols = [];

  for (const oversizedSymbol of gameController.overSizedSymbols) {
    const { row, reel } = oversizedSymbol.cell;
    const key = `${row}:${reel}`;

    if (winningSet.has(key)) continue;

    const isWinning = winningSymbols.some((winningSymbol) =>
      winningSymbol.positions.some(
        (pos) => pos.row === row && pos.reel === reel
      )
    );

    if (isWinning) {
      winningOversizedSymbols.push(oversizedSymbol);
      winningSet.add(key);
    }
  }

  gameController.winningOversizedSymbols = winningOversizedSymbols;

  gameController.nonWinningOversizedSymbols =
    gameController.overSizedSymbols.filter(
      (symbol) => !winningOversizedSymbols.includes(symbol)
    );
};

gameController.hideOversized = function (symInfo, oversizedId) {
  if (oversizedId) {
    symInfo.symbolId = oversizedId;
  }
  gameController.overSizedSymbolsAnimator.untrackOversized(
    [symInfo],
    gameController.slotMachine
  );
};

gameController.stopAnticipation = function () {
  // stop all anticipation sounds
  for (let i = 3; i <= 6; i++) {
    soundManager.stop("anticipation" + i);
  }
  gameController.longSpinBlue.visible = false;
  gameController.longSpinOrange.visible = false;
  gameController.longSpinBlue.gotoAndStop(0);
  gameController.longSpinOrange.gotoAndStop(0);
};

gameController.doSpin = function (spinTask) {
  if (gameController.inCashLink) {
    gameController.valueOverlays.clearValues();
  }
  // Update autoplay button text
  if (resourceManager.getController("autoplayController").Enabled) {
    resourceManager
      .getController("inputOverlord")
      .setText(
        "autoplayCancelButton",
        String(autoplayManager.getRemainingRounds())
      );
  }

  gameController.preRespinWinnings = 0;
  gameController.skipWinsPressed = false;

  gameController.coinValues = [];
  gameController.powerPackValues = [];

  if (spinTask.data.cashLink) {
    gameController.cashLinkCoin = spinTask.data.cashLink.cashLinkCoin;
  }

  gameController.totalWinnings = 0;
  gameController.isPrePaid = spinTask.data.isPrePaidGame;
  gameController.spinHasWin = spinTask.data.totalWinnings;

  gameController.stateMachine.switchState("SPIN_REELS_SPINNING");

  gameData.reelsSpinning = gameData.numReels;

  gameController.longSpinReels = [false, false, false, false, false, false];

  const symbolsInfo = resourceManager.getConfiguration().symbols;
  // Set up data for the reels
  let symbols = [];
  let above = [];
  let below = [];
  gameController.powerPackValues = spinTask.data.powerPacks;
  let powerPackIsPossible = false;
  gameController.powerPackValues.forEach(function (pack) {
    if (pack.reel === 0) {
      powerPackIsPossible = true;
    }
  });

  for (let reel = 0; reel < spinTask.data.resultPanel.reelList.length; reel++) {
    symbols.push([]);
    above.push([]);
    below.push([]);
    for (
      let row = 0;
      row < spinTask.data.resultPanel.reelList[reel].symbols.length;
      row++
    ) {
      const symbolId =
        spinTask.data.resultPanel.reelList[reel].symbols[row].value;
      symbols[reel].push(symbolId);
      if (symbolId === symbolsInfo["Symbol_Moon"].ID) {
        gameController.longSpinReels[5] = true;
      }
      if (symbolId === symbolsInfo["Symbol_Cashlink"].ID) {
        gameController.longSpinReels[5] = true;
      }
      if (symbolId === symbolsInfo["Symbol_Coin"].ID) {
        gameController.longSpinReels[5] = true;
      }

      if (powerPackIsPossible) {
        gameController.longSpinReels[reel] = true;
        if (gameController.cashLinkCoin) {
          if (reel > gameController.cashLinkCoin.coord.reel) {
            gameController.longSpinReels[5] = true;
          }
        }
      }
      for (
        let row = 0;
        row < spinTask.data.resultPanel.symbolsAbove[reel].symbols.length;
        row++
      ) {
        above[reel].push(
          spinTask.data.resultPanel.symbolsAbove[reel].symbols[row].value
        );
      }
      for (
        let row = 0;
        row < spinTask.data.resultPanel.symbolsBelow[reel].symbols.length;
        row++
      ) {
        below[reel].push(
          spinTask.data.resultPanel.symbolsBelow[reel].symbols[row].value
        );
      }
    }
  }

  if (spinTask.data.moons) {
    gameController.setMoonValues(spinTask);
  }

  if (spinTask.data.coins) {
    gameController.setCoinValues(spinTask);
  }

  messageBus.postImmediate("spinner:SpinEventStarted");

  //Anticipation
  gameController.slotMachine._currentMode.stopDistances =
    gameController.originalStopDistances;
  let newStopDistances = [];
  for (let r = 0; r < gameController.longSpinReels.length; ++r) {
    newStopDistances.push(gameController.originalStopDistances[r]);
    if (gameController.longSpinReels[r]) {
      if (gameController.inFreeSpins) {
        newStopDistances[r - 1] += 20;
      } else {
        newStopDistances[r - 1] += 20;
      }
    }
  }

  gameController.slotMachine._currentMode.stopDistances = newStopDistances;

  gameController.isFbl = spinTask.data.isFbl;
  gameController.isPotBonus = spinTask.data.isPotBonus;

  gameController.slotMachine.stopReels(
    symbols,
    above,
    below,
    gameController.onSpinComplete
  );
  gameData.spinData = spinTask.data;
  gameController.spinTask = spinTask;
  gameController.spinTask.join();
};

gameController.setMoonValues = function (spinTask) {
  if (!gameController.moonValues || gameController.moonValues.length === 0) {
    gameController.moonValues = spinTask.data.moons;
  }
};

gameController.setSpinMoonValues = function () {
  for (let i = 0; i < gameController.moonValues.length; i++) {
    gameController.valuesSpin.showSpinMoonValue(
      true,
      gameData.spinData.moons[i].slotCell,
      gameData.spinData.moons[i].numberOfSpins
    );
  }
};

gameController.setCoinValues = function (spinTask) {
  if (!gameController.coinValues || gameController.coinValues.length === 0) {
    gameController.coinValues = spinTask.data.coins;
  }

  for (let i = 0; i < gameController.coinValues.length; i++) {
    const slotCell =
      gameController.coinValues[i].reel * gameData.numRows +
      gameController.coinValues[i].row;

    if (gameController.coinValues[i].type === "Cash") {
      gameController.topValueOverlays.setCoinValue(
        slotCell,
        gameController.coinValues[i]
      );
      gameController.valuesSpin.setCoinSpinValue(
        slotCell,
        gameController.coinValues[i].amount
      );
    }
  }
};

gameController.initNewSpin = function () {
  timerManager.stop(gameController.cycleWinsDelayTimer);
  gameController.cancelWildTimers();
  gameController.stopAnticipation();
  gameController.stakeChanged = false;
  gameData.winningsText.skip();

  gameController.reelsAlreadyLanded = [];
  gameController.startNextSpin = false;
  gameController.isInWolfRun = false;
  gameController.randomMoonID = gameController.cachedStart = false;
  gameController.winSkipped = false;
  gameController.spinHasWin = false;
  if (!gameController.inFreeSpins) {
    gameController.messageBox.onMessageSpin();
  }
  gameController.doBigWinShake = false;

  gameController.wildLandAnimator.skip();
  gameController.wildSymbolsToStandOut = [];

  gameController.winControllerMain.skipAnimations();

  const goldenBetButton = resourceManager.get("goldenBetToggleButton");
  goldenBetButton.onSpin();

  gameController.bonusSymbolsLanded = 0;
  gameController.moonsSymbolsLanded = 0;
  gameController.slamStopped = false;
  gameController.playSingleBonus = true;
  gameController.waitingForLandAnim = false;
  gameController.cyclingWins = false;
  gameController.bigWin._newSpin = true;
  gameController.bigWin._newSpin = false;
  gameController.lastPayWinsData = undefined;
  gameController.spinComplete = false;

  gameController.winningsContainer.visible = false;
  gameData.winningsMeter.set(0);
  gameData.winningsMeterMobile.set(0);

  if (gameController.currentReelSpin !== undefined) {
    soundManager.stop(gameController.currentReelSpin);
  }
  if (!gameController.inFreeSpins && !autoplayManager.isAutoplayEnabled()) {
    // we only have one reel spin sound
    gameController.currentReelSpin = soundManager.play(
      gameController.reelspins[0]
    );
  }

  gameController.reelStopping = [false, false, false, false, false, false];
  gameController.slotMachine.infiniteSpin();
  gameController.setState_WaitingForServer();
  gameController.featurePrize = 0;
  gameController.reelsPrize = 0;

  if (!gameController.inFreeSpins) {
    gameController.stopIdleMusicTimer();
    gameData.musicManager.increaseBaseLevel();
  }
};

gameController.setWinningsText = function (finalCount = false) {
  const currentStake = resourceManager
    .getController("stakeController")
    .getBaseStake();

  let winnings = gameController.spinHasWin;

  if (
    finalCount ||
    gameController.lastPayWinsData.totalLineWinnings < currentStake * 5 ||
    gameController.skipWinsPressed
  ) {
    gameData.winningsText.setText(winnings);
  } else {
    gameData.musicManager.startCountUp();

    const obj = { amount: 0 };
    gameController.winningsCountup = gsap.to(obj, {
      duration: 0.9,
      amount: winnings,
      onUpdate: () => {
        gameData.winningsText.setText(obj.amount);
      },
      onComplete: () => {
        gameData.musicManager.endCountUp();
        gameController.winningsCountup = undefined;
      },
    });
  }
};

gameController.stopIdleMusicTimer = function () {
  timerManager.stop(gameController.idleMusicTimer);
  gameController.idleMusicTimer = undefined;
};

gameController.initNewGame = function () {
  gameController.stopCyclingWins();
  gameController.muteCyclingWins = false;
  gameController.dimOversized(gameController.overSizedSymbols, false, 0.1); //reset oversized symbols dim
  gameController.hideAllOversized();
  gameController.overSizedSymbols = [];
  gameController.winningOversizedSymbols = [];
  gameController.nonWinningOversizedSymbols = [];
  gameController.inBuyABonusFirstSpin = true;
  gameController.totalWinBeforeFreeSpins = 0;

  gameController.preFSReelPrize = 0;
  gameController.stateMachine.switchState("GAME_PLAYING");
  gameController.initNewSpin();
  if (resourceManager.getController("autoplayController").Enabled) {
    resourceManager
      .getController("inputOverlord")
      .setText(
        "autoplayCancelButton",
        String(autoplayManager.getRemainingRounds())
      );
    resourceManager
      .getController("inputOverlord")
      .setText(
        "autoplayCancelButton_portrait",
        String(autoplayManager.getRemainingRounds())
      );
  }
};

gameController.clearMoonValues = function () {
  gameController.moonValues.forEach((moon) => {
    gameController.valuesMoons.showMoonValue(
      false,
      moon.slotCell,
      moon.numberOfSpins
    );
    gameController.valuesMoons.playMoonMovie(moon.slotCell, false);
    gameController.moonValues = [];
  });
};

gameController.clearCoinValues = function () {
  //PUT SPIN VALUES ON SYMBOLS TO SPIN OFF
  gameController.coinValues.forEach((coin) => {
    if (coin.type === "Cash") {
      gameController.topValueOverlays.setCoinValue(coin.slotCell, coin.amount);
      gameController.valuesSpin.setCoinSpinValue(coin.slotCell, coin.amount);
      gameController.valuesSpin.showSpinCoinValue(true, coin.slotCell);
    } else {
      gameController.topValueOverlays.showCoinValue(false, coin.slotCell);
      gameController.valuesSpin.showSpinPotValue(
        true,
        coin.slotCell,
        coin.potName
      );
    }
    //HIDE OVERLAYS
    gameController.topValueOverlays.removeAllChildren();
  });
};

gameController.clearPowerPackValues = function () {
  gameController.powerPackValues.forEach((pack) => {
    gameController.powerPackDisplay.resetPowerPacksValues(pack.slotCell);
  });
};

gameController.clearMoonAnims = function () {
  gameController.moonValues.forEach((moon) => {
    gameController.valuesMoons.playMoonMovie(moon.slotCell, false);
  });
};

gameController.startGame = function () {
  gameController.reelStopping = [false, false, false, false, false, false];
  gameController.overSizedInProcess = true;
  //For moons insuffienct funds fix >> ReelSpinnerVisualStacked
  let currentStake = gameData.stakes[gameData.currentStakeIndex];
  if (Loader.isLoaded) {
    if (gameData.credit >= currentStake) {
      gameData.canAfford = true;
    } else {
      gameData.canAfford = false;
    }
  }

  gameController.setSpinMoonValues(); //Set spin values before we replace the moon data with new spin info

  if (gameController.wasInCoinAwardsMod || gameController.wasCashLink) {
    gameController.inCoinAwardsModifier = false;
    gameController.inCashLinkAwardDisplay = false;
    gameController.wasInCoinAwardsMod = false;
    gameController.wasCashLink = false;
    gameController.powerPackDisplay.reset();
  }
  gameController.topValueOverlays.clearAllCoinAndPotValues();

  gameController.powerPacksLanded = [];
  gameController.stopSymbolFrameDisplay();
  gameController.hasBeenWinCapped = false;
  gameController.cashLinkBonusIsPossible = false;

  gameController.clearCoinValues();
  gameController.clearPowerPackValues();

  gameController.justHadFreeSpins = false;
  gameController.stoppingAutoplay = false;

  gameController.initNewGame();

  gameController.clearMoonValues();

  const stakeController = resourceManager.getController("stakeController");
  let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;
  gdk.startGame(
    {
      stake: stakeController.CurrentStake,
      numWinlines: stakeController.CurrentWinLineCount,
      bpl: bpl,
      metaData: {
        buyABonus: false,
        encore: gameData.encoreEnabled,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

gameController.setState_WaitingForServer = function (eventToLeave) {
  if (!gameController.inFreeSpins) {
    // Only monitor how long we are waiting for server if we arent in freespins
    gameController.stateMachine.switchState("WAITING_FOR_SERVER");
  }

  if (
    checkForDefined(eventToLeave) &&
    !gameController.powerPackSymAnimating &&
    !gameController.wildBounceSymAnimating &&
    !gameController.moonSymAnimating &&
    !gameController.coinSymAnimating &&
    !gameController.cashLinkSymAnimating &&
    !gameController.overSizedInProcess
  ) {
    eventToLeave.leave();
  } else if (checkForDefined(eventToLeave)) {
    gameController.stateMachine.switchState("WAITING_FOR_SERVER");
  }
};

gameController.autoplayStarted = function (autoplayData) {
  resourceManager
    .getController("inputOverlord")
    .setText(
      "autoplayCancelButton",
      String(autoplayManager.getRemainingRounds())
    );
};

gameController.autoplayEnded = function (autoplayData) {
  resourceManager
    .getController("inputOverlord")
    .setTranslatonPhrase("autoplayButton", "t_autoplay");
};

StateMachine.Create(gameController);

gameController.stateMachine.addState("WAITING_FOR_LOAD", function () {});

gameController.cancelAutoplay = function () {
  resourceManager.getController("autoplayController").cancel();
};

gameController.stateMachine.addState("WAITING_FOR_START", function () {
  if (gameController.phase.enter()) {
    resourceManager.getController("autoplayController").checkLimits();
  }

  if (gameController.phase.hold()) {
    if (!resourceManager.getController("autoplayController").LimitPopupOpen) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    if (
      !autoplayManager.isAutoplayEnabled() &&
      !gameController.justHadFreeSpins &&
      !gameController.startNextSpin &&
      !gameController.wasCashLink
    ) {
      gameController.cyclingWins = true;
      gameController.cycleWins();
    }
  }

  if (gameController.phase.hold()) {
    // Waiting for player to do something
    if (autoplayManager.isAutoplayEnabled()) {
      if (
        autoplayManager.AP.getFields()["numberOfRounds"].currentValue !==
        autoplayManager.AP.roundsRemaining()
      ) {
        resourceManager.getController(
          "autoplayController"
        ).timeToNextAutoplay = 500; //dlConst.DELAY_BETWEEN_SPINS;
        gameController.phase.step();
      }
    } else if (gameController.startNextSpin) {
      gameController.phase.step();
    }
  }
  if (!gameController.startNextSpin) {
    if (
      gameController.phase.timed(
        resourceManager.getController("autoplayController").timeToNextAutoplay
      )
    ) {
    }
  }
  if (gameController.phase.once()) {
    if (gameController.stoppingAutoplay) {
      gameController.stoppingAutoplay = false;
      gameController.cancelAutoplay();
    } else {
      gameController.startGame();
    }

    if (autoplayManager.AP.roundsRemaining() === 0) {
      // Last round, so cancel autoplays
      gameController.cancelAutoplay();
    }
  }
});

gameController.stateMachine.addState("RETRIGGER", function () {
  if (gameController.phase.enter()) {
  }

  if (gameController.phase.hold()) {
    if (!soundManager.isSoundPlaying("BellRing")) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    gameController.retriggerTask.leave();
    gameController.retriggerTask = undefined;

    gameController.stateMachine.switchState("WAITING_FOR_SERVER");
  }
});

gameController.stateMachine.addState("SPIN_REELS_SPINNING", function () {
  for (let i = 0; i < gameData.reels.length; i++) {
    if (
      gameData.reels[i]._reelSpinnerData._postInjector
        ._targetSymbolsLeftTilLand < 5 &&
      gameController.reelStopping[i] === false &&
      gameController.wildWolfRun.active === false
    ) {
      if (!gameController.isInWolfRun) {
        gameController.reelStopping[i] = true;
      }
    }
  }
});

gameController.stateMachine.addState("WAITING_FOR_SERVER", function () {
  if (gameController.phase.enter()) {
  }
  if (gameController.phase.hold()) {
    if (
      !gameController.powerPackSymAnimating &&
      !gameController.wildBounceSymAnimating &&
      !gameController.moonSymAnimating &&
      !gameController.coinSymAnimating &&
      !gameController.cashLinkSymAnimating &&
      !gameController.overSizedInProcess
    ) {
      gameController.setState_WaitingForServer(gameController.spinTask);
      gameController.phase.step(); //TODO HB: DO i NEED THIS?>
    }
  }
  if (gameController.phase.exit()) {
  }
});

gameController.stateMachine.addState("PAYING_TO_WINNINGS", function () {
  if (gameController.phase.enter()) {
    winMeter.meter.cancelCountUp();
  }

  if (gameController.phase.hold()) {
    if (
      !gameData.winningsMeter.Props.isCounting ||
      gameData.winningsMeterMobile.Props.isCounting
    ) {
      // Finished counting
      if (!gameData.slotConfig.promotionActive) {
        //TODO: Was in golden catch
        // resourceManager.get("winningsMeterLabel").visible = true;
      }
    } else {
      if (!gameData.slotConfig.promotionActive) {
        //TODO: Was in golden catch
        // resourceManager.get("winningsMeterLabel").visible =
        //   gameController.gameTime % 200 < 100;
      }
    }
  }

  if (gameController.phase.exit()) {
    if (!gameData.slotConfig.promotionActive) {
      //TODO: Was in golden catch
      // resourceManager.get("winningsMeterLabel").visible = true;
    }
  }
});

gameController.stateMachine.addState("GAME_PLAYING", function () {
  if (gameController.phase.enter()) {
  }
});

gameController.stateMachine.switchState("WAITING_FOR_LOAD");

gameController.update = function (delta, time) {
  gameController.stateMachine.update();
};

gameController.cycleWins = function (once, callback) {
  if (gameController.cyclingWins) {
    if (
      gameController.lastPayWinsData !== undefined &&
      gameController.lastPayWinsData.winningLines !== undefined
    ) {
      gameController.cyclingWinsIndex = 0;
      gameController.cycleWin();
    }
  }
};

gameController.cycleWin = function () {
  let canCelebrate =
    this.lastPayWinsData.totalLineWinnings >
    resourceManager.getController("stakeController").CurrentStake;

  if (gameController.lastPayWinsData.winningLines.length !== 0) {
    gameController.symbolAnimating = true;

    let data =
      gameController.lastPayWinsData.winningLines[
        gameController.cyclingWinsIndex
      ];

    gameController.winlinePopup.visible = true;

    gameController.winlinePopupText.setTranslationParameters(
      data.winningLine,
      gdk.formatCurrency(data.winAmount)
    );

    let symbols = [];

    for (let i = 0; i < data.positions.length; ++i) {
      symbols.push({
        cell: { reel: data.positions[i].reel, row: data.positions[i].row },
        symbolId: data.symbol.ids[i],
      });
    }
    // gameController.playAllOversizedMovies();
    if (canCelebrate) {
      gameController.symbolAnimator.animateSymbols(
        symbols,
        gameController.slotMachine,
        canCelebrate,
        false,
        function () {
          gameController.cycleWinDelay();
        },
        undefined,
        undefined,
        undefined,
        true
      );
    } else {
      timerManager.addTimer(1350, undefined, function () {
        gameController.cycleWinDelay();
      });
    }

    let frameData = {
      winningLines: [
        gameController.lastPayWinsData.winningLines[
          gameController.cyclingWinsIndex
        ],
      ],
    };

    gameController.animating = true;

    gameController.displaySymbolFrames(frameData);
  }
};

gameController.displaySymbolFrames = function (data, displayingAll = false) {
  let symbols = new Set();

  for (let i = 0; i < data.winningLines.length; i++) {
    for (let j = 0; j < data.winningLines[i].positions.length; j++) {
      const symbol = JSON.stringify({
        reel: data.winningLines[i].positions[j].reel,
        row: data.winningLines[i].positions[j].row,
      });
      symbols.add(symbol);
    }
  }

  for (let i = 0; i < symbols.size; i++) {
    const sym = JSON.parse(Array.from(symbols)[i]);
    let mainReelScaleX = resourceManager.get("slotContainer").scale.x;
    let mainReelScaleY = resourceManager.get("slotContainer").scale.y;
    gameController.symbolFramePanels[sym.reel][sym.row].scale.set(
      mainReelScaleX,
      mainReelScaleY
    );

    const pos = helpers.getSymbolPos(sym.reel, sym.row);
    gameController.symbolFramePanels[sym.reel][sym.row].x = pos.x;
    gameController.symbolFramePanels[sym.reel][sym.row].y = pos.y;
    gameController.symbolFramePanels[sym.reel][sym.row].visible = true;

    gameController.symbolFramePanels[sym.reel][sym.row].onComplete =
      function () {
        gameController.symbolFramePanels[sym.reel][sym.row].gotoAndStop(0);
        if (displayingAll) gameController.cycleWinDelay();
      };
    gameController.symbolFramePanels[sym.reel][sym.row].gotoAndPlay(0);
  }
};

gameController.cycleWinDelay = function () {
  gameController.animating = false;
  gameController.symbolAnimating = false;
  gameController.stopSymbolFrameDisplay();
  gameController.cycleNextWin();
};

gameController.cycleNextWin = function () {
  if (
    gameController.cyclingWins &&
    !gameController.symbolAnimating &&
    !gameController.animating &&
    gameController.lastPayWinsData &&
    gameController.lastPayWinsData.winningLines
  ) {
    if (
      gameController.cyclingWinsIndex <
      gameController.lastPayWinsData.winningLines.length - 1
    ) {
      gameController.cyclingWinsIndex++;
      gameController.cycleWin();
    } else {
      gameController.cycleWins();
    }
  } else {
    gameController.cycleWins();
  }

  gameController.muteCyclingWins = true;
};

gameController.onLimitsPopupClosed = function () {
  soundManager.play(gameData.sounds.buttonPressed);
  gameController.stateMachine.switchState("GAME_ENDED");
};

// helper function to get the current stake based on game mode
// e.g. base game, buy a bonus, golden bet - don't recalculate here it's returned correctly
gameController.getCurrentModeStake = function (ignoreGoldenBetMultiplier) {
  let stake = 0;
  const stakeController = resourceManager.getController("stakeController");
  if (stakeController) {
    stake = stakeController.getCurrentStake("default");

    if (gameController.inBuyABonus) {
      stake = stakeController.getCurrentStake(
        gameController.buyABonusCashLink ? "CASHLINK_BUY" : "FREESPINS_BUY"
      );
    }

    let goldenBetButton = resourceManager.get("goldenBetToggleButton");
    if (
      ignoreGoldenBetMultiplier &&
      goldenBetButton !== undefined &&
      goldenBetButton._flags.showGoldenBetActive
    ) {
      stake = stake / gameData.luckyBetUplift;
    }
  }
  return stake;
};

gameController.onStakeChanged = function (stake) {
  let currentStake = gameData.stakes[gameData.currentStakeIndex];
  let winningsMeter = resourceManager.get("winlinePopupContainer");

  if (stake === undefined) {
    return;
  }

  //For moons insuffienct funds fix >> ReelSpinnerVisualStacked
  if (Loader.isLoaded) {
    if (gameData.credit >= stake) {
      gameData.canAfford = true;
    } else {
      gameData.canAfford = false;
    }
  }

  if (currentStake !== stake) {
    gameData.currentStakeIndex = gameData.stakes.indexOf(stake);

    game.changeStake(stake);
  }

  if (
    gameController.stakeChanged &&
    !gameController.justLeftBuyABonus &&
    !gameController.justEnteredBuyABonus
  ) {
    game.resetWinnings();

    if (winningsMeter) {
      winningsMeter.visible = false;
    }
  } else {
    gameController.justLeftBuyABonus = false;
  }
  gameData.stakeMeter.set(stake);
  gameData.stakeMeterMobile.set(stake);

  if (
    !gameController.justEnteredBuyABonus &&
    gameController.stakeChanged &&
    gameData.encoreEnabled
  ) {
    gameController.stopSymbolFrameDisplay();
    gameController.cyclingWins = false;
    gameController.lastPayWinsData = undefined;
  }

  gameController.pots.updatePots(stake);

  gdk.playerChangedStake(stake);
};

gameController.onGameConfigEvent = function () {
  gameController.gameLoaded = true;
};

gameController.onGameComplete = function () {
  if (
    gameController.totalWinnings !== 0 ||
    gameController.wasCashLink ||
    gameController.justHadFreeSpins
  ) {
    gameController.winningsContainer.visible = true;
  }

  if (!gameController.isPrePaid && !gdk.serverParser._inReplayMode) {
    gameData.creditMeter.set(
      gameData.credit +
        gameController.reelsPrize +
        gameController.freespinsWinnings +
        gameController.potBonusWinnings +
        gameController.fullGameWinnings +
        gameController.cashLinkWinnings
    );
    gameData.creditMeterMobile.set(
      gameData.credit +
        gameController.reelsPrize +
        gameController.freespinsWinnings +
        gameController.potBonusWinnings +
        gameController.fullGameWinnings
    );
  }

  gameController.fullGameWinnings = 0;
  gameController.freespinsWinnings = 0;
  gameController.cashLinkWinnings = 0;
  gameController.winSkipped = false;
  gameController.cashLinkSkip = true;
  gameController.coinAwardsSkip = true;
  gameController.potBonusWinnings = 0;
  gameController.reelsPrize = 0;
  gameController.multiplier = 0;
  gameController.inBuyABonusRecovery = false;

  if (
    !autoplayManager.isAutoplayEnabled() &&
    !gameController.freespinsLastSpin
  ) {
    gameController.idleMusicTimer = timerManager.addTimer(
      6000,
      function (progress) {},
      function () {
        gameData.musicManager.decreaseBaseLevel();
        gameController.idleMusicTimer = undefined;
      }
    );
  }

  if (gameController.inBuyABonus) {
    // restore the original stake
    gameController.justLeftBuyABonus = true;
    let stakeController = resourceManager.getController("stakeController");
    stakeController.broadcastCurrentStake("default");
  }

  // must do this here else symbols retain the buy a bonus values
  gameController.inBuyABonus = false;
  gameController.cashLinkCoin = undefined;

  if (gameController.isInWolfRun) {
    gameController.wildWolfRun.resetWildWolfRun();
  }

  gdk.endGame(function () {
    resourceManager.getController("autoplayController").checkLimits();
    // Check again in case we just cancelled autoplay
    if (autoplayManager.isAutoplayEnabled() === false) {
      resourceManager.getController("inputOverlord").setState("enabled");
      gameController.stateMachine.switchState("WAITING_FOR_START");
    } else {
      // Next game is AUTOPLAY
      gameController.stateMachine.switchState("WAITING_FOR_START");
    }
  });
};

gameController.doSlamStop = function () {
  if (gameData.reelsSpinning > 0) {
    gameController.slamStopped = true;

    gameController.stopAnticipation();

    gameController.reelsToSlam = [];

    for (let i = 0; i < gameController.longSpinReels.length; ++i) {
      gameController.reelsToSlam.push(i);
    }

    gameController.valuesSpin.removeAllChildren();
    gameController.reelStopping = [true, true, true, true, true, true];

    gameController.slotMachine.slamReels(gameController.reelsToSlam);

    gameController.powerPackSymAnimating = false;
    gameController.wildBounceSymAnimating = false;
    gameController.coinSymAnimating = false;
    gameController.cashLinkSymAnimating = false;
    gameController.moonSymAnimating = false;
  }
};

gameController.finishPayWins = function () {
  gameController.slotMachine.dimAllSymbols(false, 0);
};

gameController.playReelOversized = function (reel) {
  let reelOversized = [];
  let winOversized = [];
  if (
    gameController.slamStopped &&
    gameController.winningOversizedSymbols.length > 0 &&
    gameController.spinHasWin >
      resourceManager
        .getController("stakeController")
        .getCurrentStake("default")
  ) {
    for (let i = 0; i < gameController.overSizedSymbols.length; i++) {
      for (let j = 0; j < gameController.winningOversizedSymbols.length; j++) {
        let osSlotcell =
          gameController.overSizedSymbols[i].cell.reel * gameData.numRows +
          gameController.overSizedSymbols[i].cell.row;
        let winSlotcell =
          gameController.winningOversizedSymbols[j].cell.reel *
            gameData.numRows +
          gameController.winningOversizedSymbols[j].cell.row;
        gameController.overSizedSymbols[i].symbolId =
          gameController.overSizedSymbols[i].oversizedSymbolID;

        if (
          gameController.overSizedSymbols[i].cell.reel === reel &&
          osSlotcell === winSlotcell
        ) {
          winOversized.push(gameController.overSizedSymbols[i]);
        }

        //find oversized that are not in winlines
        const unfilteredListItems = winOversized.filter((data) => {
          return !gameController.overSizedSymbols.some((listItem) => {
            return (
              listItem.cell.row === data.cell.row &&
              listItem.cell.reel === data.cell.reel
            );
          });
        });

        gameController.animateOversized(unfilteredListItems);
      }
    }
  } else {
    for (let i = 0; i < gameController.overSizedSymbols.length; i++) {
      gameController.overSizedSymbols[i].symbolId =
        gameController.overSizedSymbols[i].oversizedSymbolID;

      if (gameController.overSizedSymbols[i].cell.reel === reel) {
        reelOversized.push(gameController.overSizedSymbols[i]);
      }
    }
  }
  gameController.animateOversized(reelOversized);
};

gameController.playAllOversizedMovies = function () {
  //Change ID to oversized
  for (let i = 0; i < gameController.overSizedSymbols.length; i++) {
    gameController.overSizedSymbols[i].symbolId =
      gameController.overSizedSymbols[i].oversizedSymbolID;
  }

  gameController.animateOversized(gameController.overSizedSymbols);
};

gameController.animateOversized = function (overSizedSyms, oversizedSymID) {
  if (oversizedSymID) {
    overSizedSyms[0].symbolId = oversizedSymID;
  }
  gameController.overSizedSymbolsAnimator.animateSymbols(
    overSizedSyms,
    gameController.slotMachine,
    true,
    true,
    function () {},
    undefined,
    undefined,
    undefined,
    true
  );
};

gameController.doPayWins = function (winTask) {
  gameController.canSkipWin = true;
  gameController.canSlamStop = false;

  gameController.winTask = winTask;
  gameController.winTask.join();

  gameController.slotMachine.clearDimSymbolIds();

  let coinWins = 0;
  if (winTask.data.coinWinnings) {
    coinWins = winTask.data.coinWinnings;
  }

  gameController.reelsPrize = winTask.data.totalLineWinnings + coinWins;

  if (!gameController.inFreeSpins || !(gameController.multiplier > 1)) {
    gameController.winningsContainer.visible = true;
    gameData.winningsMeter.add(gameController.winTask.data.totalLineWinnings);
    gameData.winningsMeterMobile.add(
      gameController.winTask.data.totalLineWinnings
    );
  }
  // coin wins added to winningsmeter in PowerPackAwardDisplay.endCallback()

  if (!gameController.inFreeSpins) {
    gameController.preFSReelPrize = gameController.reelsPrize;
    gameController.totalWinnings +=
      gameController.winTask.data.totalLineWinnings + coinWins;
  }

  let stake = resourceManager.getController("stakeController").CurrentStake;

  gameController.lastPayWinsData = winTask.data;
  for (let i = 0; i < gameController.lastPayWinsData.winningLines.length; i++) {
    let frameData = {
      winningLines: [gameController.lastPayWinsData.winningLines[i]],
    };

    gameController.displaySymbolFrames(frameData, true);
  }

  gameController.dimNonWinOversizedSyms(winTask.data.winningLines);

  if (gameController.isInWolfRun) {
    gameController.wildWolfRun.resetWildWolfRun();
  }

  if (gameController.winTask.data.totalLineWinnings >= stake) {
    gameController.winControllerMain.startAnimations(
      gameController.winTask.data,
      resourceManager.getController("stakeController").CurrentStake,
      gameController.slotMachine,
      gameController.winlinePreAnimsDone.bind(this)
    );
  } else {
    gameController.winControllerMain.playWinSounds(
      gameController.winTask.data,
      stake
    );
    gameController.winlinePreAnimsDone();
  }
};

gameController.stopCyclingWins = function () {
  gameController.skipWinsPressed = false;
  gameController.cyclingWins = false;
  gameController.symbolAnimator.skip();
  gameController.lastPayWinsData = undefined;
  gameController.cyclingWinsIndex = 0;
  gameController.stopSymbolFrameDisplay();
  gameController.winlinePopup.visible = false;
};

gameController.stopSymbolFrameDisplay = function () {
  for (let i = 0; i < gameData.numReels; i++) {
    for (let j = 0; j < gameData.numRows; j++) {
      gameController.symbolFramePanels[i][j].visible = false;
      gameController.symbolFramePanels[i][j].gotoAndStop(0);
    }
  }
};

gameController.dimNonWinOversizedSyms = function (winningLines) {
  let winningPositions = [];
  for (let i = 0; i < winningLines.length; ++i) {
    let winningLine = winningLines[i];
    let positions = winningLine.positions;
    for (let j = 0; j < positions.length; ++j) {
      let cell = positions[j];
      winningPositions.push(cell.reel * gameData.numRows + cell.row);
    }
  }

  let symbolsToDim = [];
  let overlaySymToDim = [];
  for (let reel = 0; reel < gameData.numReels; ++reel) {
    for (let row = 0; row < gameData.numRows; ++row) {
      if (winningPositions.indexOf(reel * gameData.numRows + row) === -1) {
        symbolsToDim.push({ reel: reel, row: row });
      }
    }
  }

  for (let i = 0; i < gameController.overSizedSymbols.length; i++) {
    for (let j = 0; j < symbolsToDim.length; j++) {
      if (
        gameController.overSizedSymbols[i].cell.reel === symbolsToDim[j].reel &&
        gameController.overSizedSymbols[i].cell.row === symbolsToDim[j].row
      ) {
        overlaySymToDim.push(gameController.overSizedSymbols[i]);
      }
    }
  }
  gameController.dimOversized(overlaySymToDim, true, 0.3);
  gameController.slotMachine.dimSymbols(symbolsToDim, true, 0.3);
};

gameController.playWinLineOversizedSymbols = function (winningLines) {
  let winningPositionsSet = new Set();

  for (let i = 0; i < winningLines.length; ++i) {
    let winningLine = winningLines[i];
    let positions = winningLine.positions;
    for (let j = 0; j < positions.length; ++j) {
      let cell = positions[j];
      winningPositionsSet.add(cell.reel * gameData.numRows + cell.row);
    }
  }

  let winningPositions = Array.from(winningPositionsSet);

  let symbolsToShow = [];
  let overlaySymToShow = [];
  for (let reel = 0; reel < gameData.numReels; ++reel) {
    for (let row = 0; row < gameData.numRows; ++row) {
      if (winningPositions.indexOf(reel * gameData.numRows + row) != -1) {
        symbolsToShow.push({ reel: reel, row: row });
      }
    }
  }

  for (let i = 0; i < gameController.overSizedSymbols.length; i++) {
    for (let j = 0; j < symbolsToShow.length; j++) {
      if (
        gameController.overSizedSymbols[i].cell.reel ===
          symbolsToShow[j].reel &&
        gameController.overSizedSymbols[i].cell.row === symbolsToShow[j].row
      ) {
        overlaySymToShow.push(gameController.overSizedSymbols[i]);
      }
    }
  }
  for (let i = 0; i < overlaySymToShow.length; i++) {
    gameController.showOversizeMovie(overlaySymToShow[i]);
  }
};

//HERE
gameController.dimOversized = function (symbols, showDim, time) {
  const oversizedTextures = resourceManager.get(
    "slotContainer:OversizedSymbolAnimator"
  ).children;
  for (let i = 0; i < symbols.length; ++i) {
    const slotCell =
      symbols[i].cell.reel * gameData.numRows + symbols[i].cell.row;
    const str = `slotContainer:OversizedSymbolAnimator:symbolAnim_${symbols[i].symbolId}_${slotCell}`;
    if (
      symbols[i].symbolId ===
        gameData.symbols["Symbol_Power_Pack_Oversized"].ID &&
      gameController.wasInCoinAwardsMod
    ) {
      gameController.powerPackDisplay.dimPowerPackTotalSym(
        symbols[i],
        showDim,
        time
      );
    } else {
      for (let j = 0; j < oversizedTextures.length; j++) {
        if (oversizedTextures[j].name.startsWith(str)) {
          for (let k = 0; k < oversizedTextures[j].children.length; k++) {
            let targetTint = showDim ? 0x777777 : 0xffffff;

            const osToDim = oversizedTextures[j].children[k];

            if (osToDim) {
              gsap.killTweensOf(osToDim);

              if (time) {
                gsap.to(osToDim, {
                  duration: time,
                  pixi: { tint: targetTint },
                });
              } else {
                osToDim.tint = targetTint;
              }
            }
          }
        }
      }
    }
  }
};

gameController.bigWinDone = function () {
  resourceManager.getContainer("DemoContainer").visible = true;

  if (gameController.inFreeSpins) {
    gameController.winningsContainer.visible = true;
    gameData.winningsMeter.countUp(gameController.spinHasWin, 1500);
    gameData.winningsMeterMobile.countUp(gameController.spinHasWin, 1500);
    gameController.totalWinnings += this.spinHasWin;
    gameController.fullGameWinnings += this.spinHasWin;
  }

  gameController.bigWinFinished = true;

  gameController.winlineAnimsDone();
};

gameController.cancelWildTimers = function () {
  gameController.wildTimers.forEach((timer) => {
    timerManager.stop(timer);
  });
};

gameController.winlinePreAnimsDone = function () {
  if (gameController.inFreeSpins) {
    if (
      gameController.winTask.data.winningLines.length > 0 &&
      gameController.multiplier > 1
    ) {
      let totalWinAmountBeforeMultplier = 0;
      for (
        let index = 0;
        index < gameController.winTask.data.winningLines.length;
        index++
      ) {
        const winLine = gameController.winTask.data.winningLines[index];
        totalWinAmountBeforeMultplier += winLine.winAmountBeforeMultiplier;
      }

      freespinsMultiplierAnim.startAnim(
        totalWinAmountBeforeMultplier,
        gameController.winTask.data.totalLineWinnings,
        gameController.multiplier,
        gameController.winlineAnimsDone.bind(this)
      );
    } else {
      if (!gameController.winTask.data.winIsCapped) {
        gameController.setWinningsText();
        gameData.winningsText.animate(true, false);
      } else {
        gameController.setWinningsText();
        gameData.winningsText.animate(false, false);
      }
    }
  } else {
    if (!gameController.winTask.data.winIsCapped) {
      gameController.setWinningsText();
      gameData.winningsText.animate(true, false);
    } else {
      gameController.setWinningsText();
      gameData.winningsText.animate(false, false);
    }
  }

  gameData.winningsText.show(true, 0);

  gameController.playWinLineOversizedSymbols(
    gameController.winTask.data.winningLines
  );

  if (!gameController.inFreeSpins) {
    timerManager.addTimeout(1000, function () {
      gameController.doBigWin(gameController.winTask.data.isCapped);
    });
  } else {
    if (
      gameController.winTask.data.winningLines.length < 1 ||
      !(gameController.multiplier > 1)
    ) {
      timerManager.addTimeout(1000, gameController.winlineAnimsDone.bind(this));
    }
  }
};

gameController.winlineAnimsDone = function () {
  gameController.slotMachine.clearDimSymbolIds();

  gameController.dimOversized(gameController.overSizedSymbols, false, 0.1);

  gameController.slotMachine.dimAllSymbols(false, 0.1);
  gameController.setWinningsText(true);
  gameData.winningsText.show(true, 0);
  gameData.winningsText.animateOut();
  gameController.animWinsFinished = true;
  gameController.canSkipWin = false;

  if (gameController.winTask) {
    gameController.winTask.leave();
    gameController.winTask = undefined;
  }
};

gameController.globalHelperGetBaseStake = function () {
  if (!gameController.gameLoaded) {
    return;
  }

  return resourceManager.getController("stakeController").getBaseStake();
};

gameController.doBigWin = function (isWinCapped, cb) {
  let winnings;
  let inFreespinsCashLink = false;
  if (gameController.inCoinAwardsModifier || gameController.inCashLink) {
    winnings = gameController.spinHasWin;
    inFreespinsCashLink = true;
  } else {
    winnings =
      gameController.lastPayWinsData.totalLineWinnings +
      gameController.preRespinWinnings;
  }

  let isBigWin = gameController.bigWin.willTriggerBigWin(winnings);
  let respinDontBigWin = false;

  if (
    (isBigWin && !gameController.inFreeSpins && !respinDontBigWin) ||
    (isBigWin && inFreespinsCashLink)
  ) {
    gameController.bigWin.start(
      winnings,
      function () {
        gameController.bigWinDone();
        if (cb) {
          cb();
        }
      },
      true,
      false
    );
  } else {
    gameController.bigWinDone();
    if (cb) {
      cb();
    }
  }
};

gameController.skipWinAnimations = function () {
  gameController.bigWin.skip(gameController.winlineAnimsDone);
  gameController.winControllerMain.skipAnimations();
};

gameController.isAnimatingWins = function () {
  return gameController.winTask !== undefined;
};

gameController.skip = function () {
  gameController.winSkipped = true;
  gameController.slotMachine.dimAllSymbols(false, 0);
  gameController.dimOversized(gameController.overSizedSymbols, false, 0.1);
  gameController.winControllerMain.skipAnimations();
};

gameController.toggleReelDark = function (show, duration = 0.3, delay = 0) {
  if (show) {
    gameController.reelDark.visible = true;
    gameController.reelDark.alpha = 0;

    gsap.to(gameController.reelDark, {
      duration,
      delay,
      alpha: 0.2,
    });
  } else {
    gsap.to(gameController.reelDark, {
      duration,
      delay,
      alpha: 0,
      onComplete: () => {
        gameController.reelDark.visible = false;
      },
    });
  }
};

gameController.skipWin = function () {
  gameController.skipWinsPressed = true;
  gameController.canSkipWin = false;
  if (gameController.winAnimationDelayTimer !== undefined) {
    timerManager.stop(gameController.winAnimationDelayTimer);
    gameController.winAnimationDelayTimer = undefined;
  }

  if (gameController.winningsCountup !== undefined) {
    gameController.winningsCountup.progress(1);
    gameController.winningsCountup = undefined;
  }

  gameController.setWinningsText(true);

  gameController.winControllerMain.skipAnimations();
  gameController.winlineAnimator.skipAnimation();
};

gameController.freespinsComplete = function (value) {
  gameController.reelsPrize = gameController.preFSReelPrize;
  gameController.featurePrize = value;
  gameController.stateMachine.switchState("IDLE");
};

gameController.onFreespinsStart = function () {
  autoplayManager.stopAutoplay();
  if (gameController.spinTask) {
    gameController.totalWinBeforeFreeSpins =
      gameController.spinTask.data.totalWinnings;
  } else {
    gameController.totalWinBeforeFreeSpins = 0;
  }
};

gameController.onFreespinsEnd = function () {
  gameController.justHadFreeSpins = true;
  gameController.inFreeSpins = false;
  gameController.messageBox.showLogo(true);
};

gameController.recoverGame = function (task) {
  gameController.wildLandAnimator.skip();
  gameController.redrawSymbols(gameController.slotMachine);

  gameData.helpPageScroll.close();
  gameController.gameRecovering = true;

  // Recovery game with encore
  if (task.data.metaData === "encore") {
    // Clear any encore effects and stop them appearing again
    gameData.encoreEnabled = task.data.metaValue;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get("goldenBetToggleButton");

    if (encoreButtonLB._flags.showGoldenBetActive !== gameData.encoreEnabled) {
      encoreButtonLB.setRecovery();
    }
  }

  if (
    (task.data.metaData === "buyABonusCashLink" ||
      task.data.metaData === "buyABonusFreeSpins") &&
    task.data.metaValue
  ) {
    let stakeController = resourceManager.getController("stakeController");

    let baseStake = gameData.recoveryStake;

    let stakes = stakeController.Stakes;
    let returnStake = stakes.find((stake) => stake === baseStake);

    if (!returnStake) {
      returnStake = stakes[0];
    }

    stakeController.requestChangeStake(returnStake);
    stakeController.requestChangeStake(baseStake, "FREESPINS_BUY");
    stakeController.requestChangeStake(baseStake, "CASHLINK_BUY");

    gameData.stakeMeter.set(baseStake);

    gameData.stakeMeterMobile.set(baseStake);

    gameController.inBuyABonusRecovery = true;
    gameController.inBuyABonus = true;
    buyBonusPopup.cashLinkSelected = task.data.metaData === "buyABonusCashLink";
    gameController.buyABonusCashLink =
      task.data.metaData === "buyABonusCashLink";
    gameController.initNewGame();
  } else {
    gameController.initNewGame();

    // Update stake
    let stakeController = resourceManager.getController("stakeController");
    // FUTURE REFERENCE - If recovery doesn't have a base stake set make sure you have restorePreviousWagersDerived defined
    let baseStake = stakeController.BaseStake;
    let goldenBetEnabled = gameData.encoreEnabled;

    stakeController.setStakeMultiplier(
      goldenBetEnabled ? gameData.luckyBetUplift : 1
    );
    gameController.onStakeChanged(
      baseStake * (goldenBetEnabled ? gameData.luckyBetUplift : 1)
    );
    stakeController.broadcastCurrentStake();
    gameController.pots.updatePots(baseStake);
  }
};

gameController.onAbortGame = function () {
  if (gameController.currentReelSpin !== undefined) {
    soundManager.stop(gameController.currentReelSpin);
  }

  // Abort the spin in the slot machine
  gameController.slotMachine.abortSpin();

  // Set starting symbols
  Loader.setStartingSymbols();

  // Force a redraw of symbols after a short delay to ensure everything is reset
  setTimeout(function () {
    gameController.redrawSymbols(gameController.slotMachine);
  }, 50);
};

gameController.replayComplete = function () {
  gameController.cyclingWins = true;
  gameController.cycleWins();
  //If replay reached cashlink i need to unsuspend basegame reels when back out
  for (let i = 0; i < gameData.numReels; i++) {
    gameData.reels[i].clearSuspendUpdates();
  }
};

gameController.onOrientationChange = function () {
  if (gameController.gameLoaded) {
    gameController.stopSymbolFrameDisplay();
    if (
      gameData.reelsSpinning === 0 ||
      !gameData.reelsSpinning ||
      gameController.inFreeSpins
    ) {
      gameController.messageBox.showLogo(true);
    } else {
      gameController.messageBox.showLogo(true);
      resourceManager.get("messageBox").visible = true;
    }
    //Backgrounds
    switch (layoutController.getCurrentLayout()) {
      case "landscape_default":
      case "landscape_mobile": {
        if (!gameController.inFreeSpins && !gameController.inCashLink) {
          resourceManager.get(
            "landscapeBackground:basegameBackground"
          ).visible = true;
          resourceManager.get(
            "landscapeBackground:freespinsBackground"
          ).visible = false;
        } else if (gameController.inCashLink || gameController.inFreeSpins) {
          resourceManager.get(
            "landscapeBackground:freespinsBackground"
          ).visible = true;
        }
        resourceManager.get(
          "portraitBackground:freespinsBackground"
        ).visible = false;
        break;
      }
      case "portrait_default":
      case "portrait_mobile":
      default: {
        if (!gameController.inFreeSpins && !gameController.inCashLink) {
          resourceManager.get(
            "portraitBackground:basegameBackground"
          ).visible = true;
          resourceManager.get(
            "portraitBackground:freespinsBackground"
          ).visible = false;
        } else if (gameController.inCashLink || gameController.inFreeSpins) {
          resourceManager.get(
            "portraitBackground:freespinsBackground"
          ).visible = true;
        }
        resourceManager.get(
          "landscapeBackground:freespinsBackground"
        ).visible = false;

        break;
      }
    }

    if (gameController.isInWolfRun) {
      this.darkBG = resourceManager.get(
        "slotContainer:wildWolfDisplay:darkBackground"
      ).visible = true;
    }
  }
};

gameController.onCashLinkStartEvent = function () {
  gameController.cancelAutoplay();
  gameController.inCashLink = true;
};

gameController.onRetriggering = function (task) {
  gameController.retriggerTask = task;
  gameController.retriggerTask.join();

  gameController.stateMachine.switchState("RETRIGGER");
};

gameController.onCashLinkEndEvent = function () {
  gameController.inCashLink = false;
  gameController.wasCashLink = true;
};

gameController.cashLinkLandedEvent = function (task) {
  task.join();
};

gameController.onCashLinkEndEvent = function () {};

gameController.onPotBonusEndEvent = function (task) {
  gameController.preFSReelPrize += task.winAmount;
};

gameController.onModal = function (event) {
  if (event.reason && event.reason !== "") {
    if (event.reason === "Platform Paused") {
      gameController.cancelAutoplay();
      autoplayManager.stopAutoplay();
      gameController.stoppingAutoplay = true;
      gameController.platformPaused = true;
    } else if (event.data && event.data === "Platform Popup Open") {
      gameController.platformPopupActive = true;
    }
  } else if (event.data) {
    if (
      event.data === "Platform Popup Close" &&
      !gameController.platformPaused
    ) {
      gameController.platformPopupActive = false;
    } else if (event.data === "Platform Resume") {
      gameController.platformPaused = false;
    }

    if (gameController.platformPopupActive || gameController.platformPaused) {
      gameController.cancelAutoplay();
      autoplayManager.stopAutoplay();
      gameController.stoppingAutoplay = true;
      messageBus.post("game:modal", {
        reason: "Keep locked",
        data: "Keep locked",
      });
    }
  }
};

gameController.getRandomInt = function (min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

Reflex.addToUpdate(gameController.update);
messageBus.subscribe("spinner:SpinEvent", gameController.doSpin);
messageBus.subscribe("autoplay:started", gameController.autoplayStarted);
messageBus.subscribe("autoplay:ended", gameController.autoplayEnded);
messageBus.subscribe("stake:stakeChanged", gameController.onStakeChanged);
messageBus.subscribe("common:RecoverGame", gameController.recoverGame);
messageBus.subscribe("common:GameCompleteEvent", gameController.onGameComplete);
messageBus.subscribe("spinner:WinningLinesEvent", gameController.doPayWins);
messageBus.subscribe("game:modal", gameController.onModal);
messageBus.subscribe(
  "spinner:FreeSpinsStartEvent",
  gameController.onFreespinsStart
);
messageBus.subscribe(
  "spinner:FreeSpinsEndEventDead",
  gameController.onFreespinsEnd
);
messageBus.subscribe("common:AbortGame", gameController.onAbortGame);
messageBus.subscribe("platform:ReplayComplete", gameController.replayComplete);
messageBus.subscribe(
  "powerPack:cashLinkStartEvent",
  gameController.onCashLinkStartEvent
);
messageBus.subscribe(
  "spinner:GameConfigEvent",
  gameController.onGameConfigEvent
);
messageBus.subscribe(
  "powerPack:cashLinkEndEventDead",
  gameController.onCashLinkEndEvent
);
messageBus.subscribe(
  "powerPack:cashLinkLandedEvent",
  gameController.cashLinkLandedEvent
);
messageBus.subscribe("8bof:initialRetrigger", gameController.onRetriggering);
messageBus.subscribe(
  "8bof:PotBonusStartEventDead",
  gameController.onPotBonusEndEvent
);

Reflex.registerEventHandler("layoutChange", gameController.onOrientationChange);
